import { LoginCallback } from '@okta/okta-react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route
} from 'react-router-dom';
import { PageLayout } from '@deere/fuel-react/PageLayout.js';

import ErrorBoundary from './components/ErrorBoundary';
import SDFormHeader from './components/SMNavBar';
import SearchStrategy from './components/SearchStrategy';
import App404 from './components/App404';
import AdminFeatures from './components/admin/AdminFeatures';
import ViewStrategy from './components/ViewStrategy';
import StrategyLanding from './components/StrategyLanding';
import StrategyFormStepper from './components/StrategyFormStepper';
import StrategyForm from './components/StrategyForm';
import SupplierSpendShift from './components/SupplierSpendShift';
import { RequiredAuth } from './components/SecureRoute';
import { oktaAuth } from './oktaAuth';

export { oktaAuth };

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="/"
      element={
        <ErrorBoundary>
          <SDFormHeader />
          <PageLayout id="main-content">
            <Outlet />
          </PageLayout>
        </ErrorBoundary>
      }
    >
      <Route path="/implicit/callback" element={<LoginCallback />} />
      <Route
        path="/adminFeatures"
        element={<RequiredAuth element={AdminFeatures} />}
      />
      <Route
        path="/supplierSpendShift"
        element={<RequiredAuth element={SupplierSpendShift} />}
      />
      <Route
        path="/createStrategy"
        element={<RequiredAuth element={StrategyFormStepper} />}
      />
      <Route
        path="/createStrategy/:strategyId"
        element={<RequiredAuth element={StrategyFormStepper} />}
      />
      <Route
        path="/editStrategy/:strategyId"
        element={<RequiredAuth element={StrategyForm} />}
      />
      <Route path="/" element={<RequiredAuth element={SearchStrategy} />} />
      <Route
        path="/viewStrategy/:strategyId"
        element={<RequiredAuth element={ViewStrategy} />}
      />
      <Route
        path="/dmsmStrategy/:strategyId"
        element={<RequiredAuth element={StrategyLanding} />}
      />
      <Route path="*" element={<App404 />} />
    </Route>
  )
);
